
const useSessionStorage = () => {
    // General set function
    const setSessionItem = (key, value) => {
        if (value === null || value === undefined) {
            sessionStorage.removeItem(key);
        } else if (typeof value === 'object') {
            sessionStorage.setItem(key, JSON.stringify(value));
        } else {
            sessionStorage.setItem(key, value);
        }
    };

    // General get function
    const getSessionItem = (key, defaultValue = null, parseJson = true) => {
        const value = sessionStorage.getItem(key);
        if (value === null) {
            return defaultValue;
        }
        if (!parseJson) {
            return value;
        }
        try {
            return JSON.parse(value);
        } catch {
            return value;
        }
    };

    // General remove function
    const removeSessionItem = (key) => {
        sessionStorage.removeItem(key);
    };

    // Clear all
    const clearSessionStorage = () => {
        sessionStorage.clear();
    };

    // Example specialized wrappers (for clarity, can use directly)
    const userSetRoles = (roles) => setSessionItem('roles', roles);
    const userGetRoles = () => getSessionItem('roles', []);
    const userSetBusinessId = (businessId) => setSessionItem('businessId', businessId);
    const userSetName = (name) => setSessionItem('name', name);
    const userSetAuthStatus = (name) => setSessionItem('authStatus', name);
    const userSetToken = (token) => setSessionItem('token', token);
    const userSetCustomerType = (customerType) => setSessionItem('customerType', customerType);
    const userSetChosenCustomerType = (customerType) => setSessionItem('chosenCustomerType', customerType);
    const userSetCompany = (company) => setSessionItem('company', company);
    const setjobTokenUuid = (jobTokenUuid) => setSessionItem('jobTokenUuid', jobTokenUuid);
    const jobSetJob = (job) => setSessionItem('job', job);
    const jobRemoveJob = () => removeSessionItem('job');
    const userGetToken = () => getSessionItem('token', null, false);
    const clearjobTokenUuid = () => removeSessionItem('jobTokenUuid');
    const getjobTokenUuid = () => getSessionItem('jobTokenUuid', null, false);
    const userGetCustomerType = () => getSessionItem('customerType', null, false);
    const userGetChosenCustomerType = () => getSessionItem('chosenCustomerType', null, false);
    const userGetCompanyName = () => getSessionItem('company', '', false);
    const userGetName = () => getSessionItem('name', '', false);
    const userGetAuthStatus = () => getSessionItem('authStatus', null, false);

    return {
        setSessionItem,
        getSessionItem,
        removeSessionItem,
        clearSessionStorage,
        userSetRoles,
        userSetBusinessId,
        userSetName,
        userSetToken,
        userSetCustomerType,
        userSetChosenCustomerType,
        userSetCompany,
        userSetAuthStatus,
        setjobTokenUuid,
        jobSetJob,
        userGetCustomerType,
        userGetChosenCustomerType,
        userGetRoles,
        userGetCompanyName,
        userGetName,
        userGetAuthStatus,
        userGetToken,
        getjobTokenUuid,
        clearjobTokenUuid,
        jobRemoveJob
    };
};

export default useSessionStorage;
